var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { RouteFiller } from "../helpers/Helpers";
import { CollaborationServiceSetup } from "../Setup";
var MobileAppController = /** @class */ (function () {
    function MobileAppController() {
    }
    /*****************************************************************************************************
        * @remark Usable even if user is not logged in!
        * Is using route "api/mobileapp/{id}" and http method "GET" to call the back-end.
    
        * @param {string} id
        * @returns {void}
    ******************************************************************************************************/
    MobileAppController.Get = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/mobileapp/{id}", __assign({}, data)),
            method: "GET",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    };
    return MobileAppController;
}());
export { MobileAppController };
/*
$PrintDebugInfo
*/ 
//# sourceMappingURL=MobileAppController.js.map